const colors = {
  darkest: "#15202B",
  darker: "#192734",
  dark: "#22303C",
  light: "#8899A6",
  primary: "#2196F3",
  primaryDark: "#1446A0",
  primaryLight: "#ADF5FF",
};

export default colors;
